import React from 'react';
import NoAdministrationItemSelected from '../../common/NoAdministrationItemSelected';
import useAdministrationEntityLists from '../useAdministrationEntityLists';
import { EntityListTypeSupported, getEntityListSpecification } from '../entityListsLib';

interface NoEntityListSelectedProps {
  entityListType: EntityListTypeSupported;
}

/**
 * Component for main part of the screen when no Entity List is selected.
 * Displays a message based on whether there are any Entity Lists or not.
 * @constructor
 */
const NoEntityListSelected: React.FC<NoEntityListSelectedProps> = React.memo(
  ({ entityListType }) => {
    const { data: entityLists } = useAdministrationEntityLists(entityListType);
    const entityListSpecification = getEntityListSpecification(entityListType);
    return (
      <NoAdministrationItemSelected
        message={`No ${entityListSpecification.title} selected`}
        secondaryMessage={
          entityLists && entityLists.length > 0
            ? `Click on a ${entityListSpecification.title} from the list`
            : `Click on the 'Create new ${entityListSpecification.title}' button on the left to create new ${entityListSpecification.title}`
        }
      />
    );
  },
);

NoEntityListSelected.displayName = 'NoEntityListSelected';
export default NoEntityListSelected;
